function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

window.SwymBeforeRender = window.SwymBeforeRender || [];
window.SwymBeforeRender.push(function (UIObj) {
  UIObj.Registry.preloadComponent("productPrice", function (OGComp8) {
    var ModWishlistPriceItem = /*#__PURE__*/function (_UIObj$React$Componen) {
      _inherits(ModWishlistPriceItem, _UIObj$React$Componen);

      var _super = _createSuper(ModWishlistPriceItem);

      function ModWishlistPriceItem(props) {
        var _this;

        _classCallCheck(this, ModWishlistPriceItem);

        _this = _super.call(this, props);
        _this.state = {
          customPriceState: false
        };
        _this.changeState = _this.changeState.bind(_assertThisInitialized(_this));
        return _this;
      }

      _createClass(ModWishlistPriceItem, [{
        key: "changeState",
        value: function changeState(state) {
          this.setState(_objectSpread(_objectSpread({}, this.state), state));
        }
      }, {
        key: "formatPrice",
        value: function formatPrice(value) {
          var currency = window._swat.currency;
          return currency + _swat.utils.padDecimal(value);
        }
      }, {
        key: "mod",
        value: function mod(epi, empi, du, changeState) {
          window._swat.getProductDetails({
            epi: epi,
            empi: empi,
            du: du
          }, function (productJson) {
            //console.log(productJson, "json");
            if (productJson.compare_at_price <= productJson.price) {
              changeState({
                customPriceState: true
              });
            }
          });
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          setTimeout(function () {
            var _this2$props$listItem = _this2.props.listItem,
                epi = _this2$props$listItem.epi,
                empi = _this2$props$listItem.empi,
                du = _this2$props$listItem.du;

            _this2.mod(epi, empi, du, _this2.changeState);
          }, 0);
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              listItem = _this$props.listItem,
              productVariant = _this$props.productVariant,
              classNames = _this$props.classNames;
          var priceLoading = productVariant && productVariant.loading;
          return this.state.customPriceState ? UIObj.Renderer.createElement("div", {
            className: "swym-product-price swym-text swym-text-1"
          }, !priceLoading && UIObj.Renderer.createElement("div", {
            "class": "swym-product-final-price swym-value"
          }, this.formatPrice(listItem.pr))) : UIObj.Renderer.createElement(OGComp8, this.props);
        }
      }]);

      return ModWishlistPriceItem;
    }(UIObj.React.Component);

    UIObj.Registry.register("WishlistContainer.Detail.Grid.Item.Price", ModWishlistPriceItem);
    UIObj.Registry.register("WishlistModal.Container.Detail.Grid.Item.Price", ModWishlistPriceItem);
  });
});
